import { createQueryClient } from "@arcadeai/ui-kit/query-client";
import { toast } from "sonner";
import {
  getHttpErrorFields,
  isAuthRecoveryHttpError,
  isHttpError,
} from "./http-error";

export const queryClient = createQueryClient({
  onMutationError: (error, errorMessage = "An error occurred") => {
    if (isAuthRecoveryHttpError(error)) {
      return;
    }

    // A 403 may mean the caller's permissions changed; refetch the authoritative
    // set. Invalidate every capabilities entry (the "capabilities" key prefix covers
    // both org and project scopes) on purpose: the change could be at either scope,
    // and refetching both is cheap, so there's no need to narrow it.
    if (isHttpError(error) && error.status === 403) {
      queryClient.invalidateQueries({ queryKey: ["capabilities"] });
    }

    if (isHttpError(error)) {
      const { name, message } = getHttpErrorFields(error);
      toast.error(`${name}: ${message}`);
    } else {
      toast.error(error instanceof Error ? error.message : errorMessage);
    }
  },
  shouldRetry: (failureCount, error) => {
    if (isHttpError(error) && error.status === 401) {
      return false;
    }
    return failureCount < 1;
  },
});
